import React from "react";
//import PropTypes from "prop-types";

import translate from "../services/translate";
//import "../styles/InfoPanel.css";

const SplashPanel = () => {

  return (
    <div className="panel">
      <div className="panelContents">
      <p>{translate("SplashPanel.para1")}</p>
      <p>{translate("SplashPanel.para2")}</p>
      <p>{translate("SplashPanel.para3")}</p>
      <p>{translate("SplashPanel.para4")}</p>
      <p>{translate("SplashPanel.para5")}</p>
      </div>
    </div>
  );
};

export default SplashPanel;
